// extracted by mini-css-extract-plugin
export default {"pagination":"index_pagination__r45+H","tHeader":"index_tHeader__qVnYo","tBodys":"index_tBodys__3CjNE","divideLine":"index_divideLine__rmeaH","noData":"index_noData__OR9-a"};